var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVerifyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5267 84C65.8537 84 84.7639 65.196 84.7639 42C84.7639 18.804 65.8537 0 42.5267 0C19.1998 0 0.289551 18.804 0.289551 42C0.289551 65.196 19.1998 84 42.5267 84Z",
    fill: "#FAE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9508 22C65.2981 22 67.2896 23.7909 67.2896 26C67.2896 28.2091 65.2981 30 63.9508 30H55.7886C57.136 30 59.1274 31.7909 59.1274 34C59.1274 36.2091 57.136 38 55.7886 38H63.9508C65.2981 38 67.2896 39.7909 67.2896 42C67.2896 44.2091 65.2981 46 63.9508 46H60.405C58.7062 46 56.4298 47.7909 56.4298 50C56.4298 51.4728 57.4266 52.8061 59.4201 54C60.7674 54 62.7589 55.7909 62.7589 58C62.7589 60.2091 60.7674 62 59.4201 62H17.2501C15.9027 62 13.9113 60.2091 13.9113 58C13.9113 55.7909 15.9027 54 17.2501 54H10.6283C9.281 54 7.28955 52.2091 7.28955 50C7.28955 47.7909 9.281 46 10.6283 46H24.5688C25.9162 46 27.9076 44.2091 27.9076 42C27.9076 39.7909 25.9162 38 24.5688 38H15.856C14.5087 38 12.5172 36.2091 12.5172 34C12.5172 31.7909 14.5087 30 15.856 30H29.7965C28.4492 30 26.4577 28.2091 26.4577 26C26.4577 23.7909 28.4492 22 29.7965 22H63.9508ZM73.2896 38C75.4987 38 77.2896 39.7909 77.2896 42C77.2896 44.2091 75.4987 46 73.2896 46C71.0804 46 69.2896 44.2091 69.2896 42C69.2896 39.7909 71.0804 38 73.2896 38Z",
    fill: "#EAB7FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 29H27C26.4477 29 26 29.4477 26 30V54C26 54.5523 26.4477 55 27 55H59C59.5523 55 60 54.5523 60 54V30C60 29.4477 59.5523 29 59 29Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58 29H28C26.8954 29 26 29.8954 26 31V53C26 54.1046 26.8954 55 28 55H58C59.1046 55 60 54.1046 60 53V31C60 29.8954 59.1046 29 58 29Z",
    stroke: "#7A2697",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32L43 42L60 32",
    stroke: "#7A2697",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerifyEmail);
export default __webpack_public_path__ + "static/media/icon-verify-email.c6cf2606d1223e21a75c3edc9990a689.svg";
export { ForwardRef as ReactComponent };